/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { ISuburbanOfferCategoryFilter } from './SuburbanOfferCategoryFilter';

export interface ISuburbanOfferHistorySpoilerFilters {
  /** Список доступным фильтров по категории **/
  categories: ISuburbanOfferCategoryFilter[];
  /** Активная категория **/
  activeCategory: EActiveCategory;
}

export enum EActiveCategory {
  /** Продажа квартиры **/
  'FlatSale' = 'flatSale',
  /** Продажа комнаты **/
  'RoomSale' = 'roomSale',
  /** Продажа квартиры в новостройке **/
  'NewBuildingFlatSale' = 'newBuildingFlatSale',
  /** Продажа доли в квартире **/
  'FlatShareSale' = 'flatShareSale',
  /** Продажа дома/дачи **/
  'HouseSale' = 'houseSale',
  /** Продажа коттеджа **/
  'CottageSale' = 'cottageSale',
  /** Продажа таунхауса **/
  'TownhouseSale' = 'townhouseSale',
  /** Продажа части дома **/
  'HouseShareSale' = 'houseShareSale',
  /** Продажа участка **/
  'LandSale' = 'landSale',
  /** Аренда квартиры **/
  'FlatRent' = 'flatRent',
  /** Аренда комнаты **/
  'RoomRent' = 'roomRent',
  /** Аренда койко-места **/
  'BedRent' = 'bedRent',
  /** Аренда дома/дачи **/
  'HouseRent' = 'houseRent',
  /** Аренда коттеджа **/
  'CottageRent' = 'cottageRent',
  /** Аренда таунхауса **/
  'TownhouseRent' = 'townhouseRent',
  /** Аренда части дома **/
  'HouseShareRent' = 'houseShareRent',
  /** Посуточная аренда квартиры **/
  'DailyFlatRent' = 'dailyFlatRent',
  /** Посуточная аренда комнаты **/
  'DailyRoomRent' = 'dailyRoomRent',
  /** Посуточная аренда койко-места **/
  'DailyBedRent' = 'dailyBedRent',
  /** Посуточная аренда дома, дачи, коттеджа **/
  'DailyHouseRent' = 'dailyHouseRent',
  /** Продажа офиса **/
  'OfficeSale' = 'officeSale',
  /** Продажа склада **/
  'WarehouseSale' = 'warehouseSale',
  /** Продажа торговой площади **/
  'ShoppingAreaSale' = 'shoppingAreaSale',
  /** Продажа производство **/
  'IndustrySale' = 'industrySale',
  /** Продажа здания **/
  'BuildingSale' = 'buildingSale',
  /** Продажа помещения свободного назначения **/
  'FreeAppointmentObjectSale' = 'freeAppointmentObjectSale',
  /** Продажа готового бизнеса **/
  'BusinessSale' = 'businessSale',
  /** Продажа коммерческой земли **/
  'CommercialLandSale' = 'commercialLandSale',
  /** Продажа гаража **/
  'GarageSale' = 'garageSale',
  /** Аренда офиса **/
  'OfficeRent' = 'officeRent',
  /** Аренда склада **/
  'WarehouseRent' = 'warehouseRent',
  /** Аренда торговой площади **/
  'ShoppingAreaRent' = 'shoppingAreaRent',
  /** Аренда производства **/
  'IndustryRent' = 'industryRent',
  /** Аренда здания **/
  'BuildingRent' = 'buildingRent',
  /** Аренда помещения свободного назначения **/
  'FreeAppointmentObjectRent' = 'freeAppointmentObjectRent',
  /** Аренда готового бизнеса **/
  'BusinessRent' = 'businessRent',
  /** Аренда коммерческой земли **/
  'CommercialLandRent' = 'commercialLandRent',
  /** Аренда гаража **/
  'GarageRent' = 'garageRent',
  /** Продажа общепита **/
  'PublicCateringSale' = 'publicCateringSale',
  /** Продажа автосервиса **/
  'CarServiceSale' = 'carServiceSale',
  /** Продажа помещения под бытовые услуги **/
  'DomesticServicesSale' = 'domesticServicesSale',
  /** Аренда общепита **/
  'PublicCateringRent' = 'publicCateringRent',
  /** Аренда автосервис **/
  'CarServiceRent' = 'carServiceRent',
  /** Аренда помещения под бытовые услуги **/
  'DomesticServicesRent' = 'domesticServicesRent',
}
